module.exports = __webpack_public_path__ + "img/ayan-nag-red-sand.042db2e.jpg";